

<template>
      
      

  <div class="row">
  <div class="col-sm-3 col-lg-3 col-xxl-3" v-for="kisi in paginatedkisiler" :key="kisi.id"  :class="{ 'tableactivetr': kisi.id === (kisiler.secili && kisiler.secili.id) }">
<div class="card card-bordered">
    <div class="card-inner">
        <div class="team">
            <div class="team-status bg-light text-black"></div>
           
            <div class="user-card user-card-s2" @click="detay(kisi)">
                <div class="user-avatar md bg-primary"> <img :src="$globalVariable.uploadUrl + kisi.gorsel"  @error="$globalVariable.varsayilanGorsel" alt="">
                </div>
                <div class="user-info">
                    <h6> {{ kisi.adsoyad }}</h6><span class="sub-text">{{ kisi.firma_ad }}</span>
                </div>
            </div>
        
          
            <div class="team-view">
              <a href="#" class="btn btn-trigger btn-icon"  @click="detay(kisi)">
            <em class="icon ni ni-eye"></em>
          </a>
              <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('kisi_duzenle')" @click="duzenle(kisi)">
            <em class="icon ni ni-pen"></em>
          </a>
        
     
          <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('kisi_sil')" @click="sil(kisi.id)">
            <em class="icon ni ni-trash-alt"></em>
          </a>
          
                  </div>
        </div>
    </div>
</div>
</div>
</div>



<div class="card-inner">
        <div class="nk-block-between-md g-3">
          <div class="g">
            <ul class="pagination justify-content-center justify-content-md-start">
              <li :class="{ active: page === kisiler.seciliSayfa, 'page-item': true }" v-for="page in pages"
                :key="page">
                <a class="page-link" href="#" @click="kisilerSayfaDegistir(page)">{{ page }}</a>
              </li>

            </ul>
          </div>

        </div>
      </div>




   

 </template>
 

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {

    kisiler:{
      type: Array,
      required: true
    },
    duzenle: Function,
    detay: Function,
    formKaydetSonrasi: Function,
    tur:String,
  },
  computed: {
    filteredkisiler() {
      // Arama filtresine göre kullanıcıları filtrele
      return this.kisiler.tumu.filter(
        (kisi) =>

          kisi.adsoyad.toLowerCase() 
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.adsoyad.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.telefon.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.email.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.adres.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.not.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.gorev.toLowerCase()
          
          .includes(this.kisiler.arananKelime.toLowerCase()) ||kisi.dil.toLowerCase()
          
          
          .includes(this.kisiler.arananKelime.toLowerCase())


    
      );
    },
    paginatedkisiler() {
      const start = (this.kisiler.seciliSayfa - 1) * this.kisiler.sayfadaKayit;
      const end = start + this.kisiler.sayfadaKayit;
      return this.filteredkisiler.slice(start, end);
    },
    kisiler_toplamSayfa() {
      const totalFilteredUsers = this.filteredkisiler.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.kisiler.sayfadaKayit), 1);
      if (this.kisiler.seciliSayfa > maxPage) {
        this.kisilerSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
        const totalPageCount = this.kisiler_toplamSayfa;
        const maxVisiblePages = 5;
        const currentPage = this.kisiler.seciliSayfa;

        if (totalPageCount <= maxVisiblePages) {
            return Array.from({ length: totalPageCount }, (_, index) => index + 1);
        }

        const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

        return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    async sil(kisiId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("kisiler/sil/" + kisiId);
          this.$toast.success("Kayıt Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    kisilerSayfaDegistir(page) {
      this.$emit('update:kisiler',{
      ...this.kisiler,
      seciliSayfa: page
    });
    },
    kisilerSayfadaKayitDegistir(value) {
      this.$emit('update:kisiler',{
      ...this.kisiler,
      sayfadaKayit: value
    });
      this.kisilerSayfaDegistir(1);
    },
  },
};
</script>
